import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["agadir-airport-to-essaouira"];

export const Route = createFileRoute("/transfers/agadir-airport-to-essaouira")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
